// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1IZUp","main":"styles-module__main___2u6Z2"};